import type { ComputedRef, InjectionKey } from 'vue'

// Tables reuse a surrounding horizontal viewport instead of nesting two rails.
export const scrollAreaHorizontalOwner: InjectionKey<ComputedRef<boolean>> = Symbol(
  'scroll-area-horizontal-owner',
)
